import { Component, input, OnInit, inject } from '@angular/core';
import { LocaleService } from '@next/core-lib/i18n';

import { Fertilizer, FertilizerType } from '../../models/fertilizer.model';

@Component({
  selector: 'app-manure-details',
  templateUrl: './manure-details.component.html',
  styleUrls: ['./manure-details.component.scss'],
  standalone: false,
})
export class ManureDetailsComponent implements OnInit {
  protected readonly locale = inject(LocaleService);

  fertilizers = input<Fertilizer[]>([]);
  isLoaded = input<boolean>(false);

  initialStockFertilizers: Fertilizer[] = [];
  notDeliveredFertilizers: Fertilizer[] = [];
  deliveredFertilizers: Fertilizer[] = [];
  dispatchedFertilizers: Fertilizer[] = [];
  closingStockFertilizers: Fertilizer[] = [];

  ngOnInit(): void {
    this.filterFertilizers();
  }

  private filterFertilizers(): void {
    const fertilizers = this.fertilizers();
    if (!fertilizers) {
      return;
    }

    this.deliveredFertilizers = fertilizers
      .filter(({ fertilizerType }) => fertilizerType === FertilizerType.Delivered)
      .reverse();

    this.notDeliveredFertilizers = fertilizers
      .filter(({ fertilizerType }) => fertilizerType === FertilizerType.NotDelivered)
      .reverse();

    this.initialStockFertilizers = fertilizers
      .filter(({ fertilizerType }) => fertilizerType === FertilizerType.InitialStock)
      .reverse();

    this.closingStockFertilizers = fertilizers
      .filter(({ fertilizerType }) => fertilizerType === FertilizerType.ClosingStock)
      .reverse();

    this.dispatchedFertilizers = fertilizers
      .filter(({ fertilizerType }) => fertilizerType === FertilizerType.Dispatched)
      .reverse();
  }
}
